import { http } from "~/utils";
export default {
    getVoas: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http
            .get("/voa/voa/", {
                params: request_filters
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    getVoaDetail: async voa_id => {
        return http.get(`/voa/voa/${voa_id}/`).then(response => response.data);
    },
    requestReport: async () => {
        return await http.post("/voa/item/report/").then(response => response.data);
    },
    requestSummaryReport: async () => {
        return await http.post("/voa/summary/report/").then(response => response.data);
    }
};
